/**
 * notification
 * 全局通用的弹窗提示
 */
// import dashboardStore from 'stores/DashboardStore';
import { notification } from '@ali/aps';
import { isEmpty, isArray } from 'lodash';
import { hashHistory } from 'react-router';
import { fetchCodeMap, Content } from 'services/NotificationService';
import { fetchCerificationUrl } from 'services/DashboardService';
import dashboardStore from 'stores/DashboardStore';
const { Tracker, Client, Share } = window.$ACE;

const PLAN = window.PLAN ? window.PLAN : 'B';

const defaultCallBack = type => {
  // 已在团中
  if (type == -116 || type == -119) {
    return hashHistory.replace('/self');
  }
};
const handleEnterpriseCustom = async ({ content, buttons }) => {
  if (PLAN == 'A') {
    if (Client.isMobile()) {
      const buttonIndex = await notification.confirm(content, { buttons, className: 'toast cerification' });
      if (buttonIndex !== 1) return;
      // 唤起弹窗
      const cerificationUrl = await fetchCerificationUrl(encodeURIComponent(location.href));
      location.href = cerificationUrl;
    } else {
      const buttonIndex = await notification.confirm(<Content title="您的账号还未实名认证，请先完成实名认证！" />, {
        buttons,
        className: 'toast',
      });
      if (buttonIndex !== 1) return;
      const targetUrl = 'https://account.console.aliyun.com/?#/auth/home';
      const redirectUrl = Tracker.addSpm(targetUrl, 'body');
      window.location.href = redirectUrl;
    }
  } else if (Client.isMobile()) {
    // 唤起弹窗
    dashboardStore.toggleCertication();
  } else {
    const buttonIndex = await notification.confirm(<Content title="您的账号还未实名认证，请先完成实名认证！" />, {
      buttons,
      className: 'toast',
    });
    if (buttonIndex !== 1) return;
    const targetUrl = 'https://account.console.aliyun.com/?#/auth/home';
    const redirectUrl = Tracker.addSpm(targetUrl, 'body');
    window.location.href = redirectUrl;
  }
};

const handleNotLogin = () => {
  const loginUrl = 'https://account.aliyun.com/login/login.htm?oauth_callback=';
  const callBackUrl = encodeURIComponent(window.location.href);
  const redirectUrl = Tracker.addSpm(loginUrl + callBackUrl, 'body');
  return (window.location.href = redirectUrl);
};

/**
 * 根据异常 code 处理接口返回值
 *
 * @param {Object} { type, callback, leftCallback }
 *  @param {String} type 成功/错误code
 *  @param {String} msg 兜底文案
 *  @param {Function} callback 右边按钮的回调，如果只有一个按钮，传入此参数
 *  @param {Function} leftCallback 左边按钮的回调
 * @return {null} none
 */
async function toast({ type, msg, callback, leftCallback }) {
  // 若未登录直接跳转到登录页
  if (type === 'notLoginError' || type === '-114' || type === '511') {
    return handleNotLogin();
  }
  // if (type === 'remind') {
  //   return notification.alert('您好，成为老用户即可拉新获得奖励！购买页面中的二折商品吧！');
  // }
  const codeMap = await fetchCodeMap();
  if (!codeMap[type]) {
    if (msg) {
      return notification.confirm(msg, { className: 'toast' });
    }
    return notification.confirm(`接口异常，code:${type}`, { className: 'toast' });
  }
  const { content, buttons } = codeMap[type];
  // 处理一下实名认证的错误
  if (type === 'UNPASS_CUSTOMER_CERTIFIED') {
    if (Client.isWeixin()) {
      return Share.toBrowser();
    }
    return handleEnterpriseCustom({ content, buttons });
  }

  const buttonIndex = await notification.confirm(content, { buttons, className: 'toast' });
  // 若 buttons 的值不存在或者不是数组直接返回
  if (isEmpty(buttons) || !isArray(buttons)) return;
  // 只有一个按钮的时候调用 callback
  if (buttons.length === 1) {
    defaultCallBack(type);
    return callback && callback();
  }
  if (buttons.length > 1) {
    if (buttonIndex === 0) {
      return leftCallback && leftCallback();
    }
    if (buttonIndex === 1) {
      defaultCallBack(type);
      return callback && callback();
    }
  }
}

export default toast;



// WEBPACK FOOTER //
// ./src/scripts/utils/notification/toast.js